import { widgetInfo, PaletteType } from "./store";
let baseUrl = "https://widget.perryweather.com/icons/weather/";
// let baseUrl: string = "/icons/weather/";
const nightCodes = ["0002", "0003", "0011",
    "2012", "2013", "2014", "2016", "2017", "2018", "2019",
    "2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030",
    "9000", "9002", "9003", "9004", "9100"];
const ignoreCodes = ["9101", "9102", "9103", "9105", "9104", "9106", "9107", "0004", "0005", "0006"];
let widget;
widgetInfo.subscribe(value => {
    widget = value;
});
export function WeatherIcon(weatherCode, date) {
    //Some weather codes are strange (e.g. 9101 = Humid) and can be shown with "clear" icon.
    if (ignoreCodes.includes(weatherCode)) {
        weatherCode = "9000";
    }
    if (date) {
        let hours = date.getHours();
        if (nightCodes.includes(weatherCode) && (hours >= 18 || hours <= 6)) {
            weatherCode = weatherCode + "_night";
        }
    }
    let theme = "light";
    if (widget && widget.theme === PaletteType.DARK)
        theme = "dark";
    return `${baseUrl}${theme}/${weatherCode}.svg`;
}
